module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header",
    class: {
      'colored-app-header': _vm.coloredAppHeader
    }
  }, [(!_vm.hideArrowBackBtn && !_vm.isBrowserView) ? _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "float-left app-header-icon mdl-button mdl-js-button mdl-button--icon mr-24",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-header__header-row",
    class: {
      'float-left': !_vm.isBrowserView, 'text-center': _vm.isBrowserView, 'w-100': _vm.isBrowserView
    }
  }, [_c('span', {
    staticClass: "app-header-title"
  }, [_vm._v(_vm._s(_vm.headerTitle))])]), _vm._v(" "), (!_vm.hideCloseBtn && !_vm.isBrowserView) ? _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "float-right app-header-icon mdl-button mdl-js-button mdl-button--icon",
    on: {
      "click": _vm.close
    }
  }, [(_vm.coloredAppHeader) ? _c('img', {
    attrs: {
      "src": "/static/images/close-white-54.svg"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/close-black-54.svg"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1810e69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 1556
// module chunks = 1